export default {
  crossIcon: 'dialog cross icon',
};
